import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './style/lib/animate.css';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react'
import { persistStore } from 'redux-persist'
import configureStore from './configureStore'
import reducer from './reducers';
import { AppContainer } from 'react-hot-loader';
import { LocaleProvider, ConfigProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import Page from './Page';

let store = configureStore();
let persistor = persistStore(store)


const render = Component => {   // 增加react-hot-loader保持状态刷新操作，如果不需要可去掉并把下面注释的打开
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <ConfigProvider
                        getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                            return document.body;
                        }}
                    >
                        <LocaleProvider locale={zh_CN}><Page /></LocaleProvider>
                    </ConfigProvider>
                </PersistGate>
            </Provider>
        </AppContainer>
        ,
        document.getElementById('root')
    );
};

render(Page);

// Webpack Hot Module Replacement API
if (module.hot) {
    // 隐藏You cannot change <Router routes>; it will be ignored 错误提示
    // react-hot-loader 使用在react-router 3.x上引起的提示，react-router 4.x不存在
    // 详情可参照https://github.com/gaearon/react-hot-loader/issues/298
    const orgError = console.error; // eslint-disable-line no-console
    console.error = (...args) => { // eslint-disable-line no-console
        if (args && args.length === 1 && typeof args[0] === 'string' && args[0].indexOf('You cannot change <Router routes>;') > -1) {
            // React route changed
        } else {
            // Log the error as normally
            orgError.apply(console, args);
        }
    };
    module.hot.accept('./Page', () => {
        render(Page);
    })
}

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js